import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: []
})
export class PeopleApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<PeopleApiModule> {
        return { ngModule: PeopleApiModule, providers: [{ provide: Configuration, useFactory: configurationFactory }] };
    }

    constructor(@Optional() @SkipSelf() parentModule: PeopleApiModule, @Optional() http: HttpClient) {
        if (parentModule) throw new Error('PeopleApiModule is already loaded. Import in your base AppModule only.');
        if (!http) throw new Error('You need to import the HttpClientModule in your AppModule!');
    }
}
